// extracted by mini-css-extract-plugin
export default {"rodape":"Footer_rodape__PTJzw"};